import React, { Component } from 'react';
import StyledSelect from 'components/Select';
import {
  PROPERTY_ATMORE,
  PROPERTY_MONTGOMERY,
  PROPERTY_WETUMPKA,
  PROPERTY_BETHLEHEM,
  PROPERTY_CHICAGO
} from 'utils/constants';

const propertyRoomFeatures = {
  [PROPERTY_CHICAGO]: [
    { value: 'AE', label: 'AWAY FROM ELEVATOR' },
    { value: 'CHAISE', label: 'CHAISE LOUNGER' },
    { value: 'COCO', label: 'COCO MANGO FLOOR' },
    { value: 'CONN', label: 'CONNECTING ROOM' },
    { value: 'ESSENCE', label: 'ESSENCE FLOOR' },
    { value: 'HF', label: 'HIGH FLOOR' },
    { value: 'HI', label: 'HEARING IMPAIRED' },
    { value: 'JAZZ', label: 'JACUZZI TUB' },
    { value: 'LF', label: 'LOW FLOOR' },
    { value: 'LOW', label: 'LOWERED BED' },
    { value: 'NE', label: 'NEAR ELEVATOR' },
    { value: 'ROAM', label: 'ROAM FLOOR' },
    { value: 'RS', label: 'ROLL IN SHOWER' },
    { value: 'TUB', label: 'TUB WITH SHOWER HEAD' },
    { value: 'VIEW', label: 'QUARRY VIEW' },
    { value: 'WC', label: 'WHEEL CHAIR ACCESSIBLE' }
  ],
  [PROPERTY_ATMORE]: [
    { value: 'SMK', label: 'Smoking Room' },
    { value: 'QN', label: 'Queen Bed' },
    { value: 'NSMK', label: 'Non-Smoking' },
    { value: 'LF', label: 'Low Floor' },
    {
      value: 'ESCAPE',
      label: 'ESCAPE ROOM TYPE APPROVED FOR THIS GUEST TO BE PLACED IN'
    },
    { value: 'KG', label: 'King Bed' },
    { value: 'HF', label: 'High Floor' },
    { value: 'TUB', label: 'Bathtub' },
    { value: 'SHWR', label: 'Shower' },
    { value: 'NOADA', label: 'DO NOT PLACE IN A HANDICAP ROOM' },
    { value: 'NE', label: 'Near Elevator' },
    { value: 'AE', label: 'Away From Elevator' },
    { value: 'VIEW', label: 'View of Lake/Pool' },
    { value: 'LOWBED', label: 'Wheelchair-Handicap Accessible Lowered Bed' },
    { value: 'NON ALLERG', label: 'NON ALLERGENIC BEDDING' },
    { value: 'ADA', label: 'Handicap Accessible' },
    { value: 'CLUB', label: 'Near RV Club House' },
    { value: 'F2CWIN', label: 'Floor To Ceiling Windows' },
    { value: 'CON', label: 'Connecting Room' }
  ],
  [PROPERTY_MONTGOMERY]: [
    { value: 'MICRO', label: 'Microwave Requested' },
    { value: 'AE', label: 'Away From Elevator' },
    { value: 'ALLERGY', label: 'Feather Free Required' },
    { value: 'CON', label: 'Connector' },
    { value: 'HF', label: 'High Floor' },
    { value: 'KG', label: 'King Bed' },
    { value: 'QN', label: 'Queen Bed' },
    { value: 'LOWBED', label: 'Guest Must Have Low Bed Access' },
    { value: 'NE', label: 'Near Elevator' },
    { value: 'NOADA', label: 'Do Not Place in ADA Room Type' },
    { value: 'NON ALLERG', label: 'Non Allergenic Room' },
    { value: 'ADA', label: 'Accessible Room Type' },
    { value: 'LF', label: 'Low Floor' }
  ],
  [PROPERTY_WETUMPKA]: [
    { value: 'CONN', label: 'Connecting Room Type' },
    { value: 'LF', label: 'Low Floor - Up to 8th Floor' },
    { value: 'HF', label: 'High Floor - 9th Floor and Higher' },
    { value: 'WC', label: 'Wheel Chair Accessible' },
    { value: 'BAL', label: 'Balcony' },
    { value: 'HI', label: 'Hearing Impaired' },
    { value: 'NE', label: 'Near Elevator' },
    { value: 'LOW', label: 'Lowered Bed' },
    { value: 'AE', label: 'Away from Elevator' },
    { value: 'JAZZ', label: 'Jacuzzi Tub' },
    { value: 'TUB', label: 'Tub with Shower head' },
    { value: 'RS', label: 'Roll In Shower' }
  ],
  [PROPERTY_BETHLEHEM]: [
    { value: 'NONCON', label: 'Non-Connecting Request' },
    { value: 'NONSM', label: 'Non-Smoking' },
    { value: 'CN', label: 'Connecting Rooms' },
    { value: 'CV', label: 'City View' },
    { value: 'HF', label: 'High Floor' },
    { value: 'KB', label: 'King Bed' },
    { value: 'LF', label: 'Low Floor' },
    { value: 'NE', label: 'Near Elevator' },
    { value: 'NIV', label: 'Near Ice and Vending Machine' },
    { value: 'NX', label: 'Near Emergency Exit' },
    { value: 'QQ', label: 'Queen Beds' },
    { value: 'RV', label: 'River View' },
    { value: 'SB', label: 'Sofa Bed' },
    { value: 'SIB', label: 'Sink in Bathroom' },
    { value: 'WC', label: 'Wheelchair Accessible' },
    { value: 'WP', label: 'Whirlpool/Jacuzzi Tub' },
    { value: 'AC', label: 'Accessible Room' },
    { value: 'AE', label: 'Away from Elevator' }
  ]
};

export class RoomFeatures extends Component {
  handleBlur = () => {
    const { input } = this.props;
    const { onBlur, value } = input;

    onBlur && onBlur(value);
  };

  render() {
    const { input, id, property } = this.props;
    const { onChange, value } = input;

    return (
      <StyledSelect
        multi={true}
        value={value}
        className="select-multi"
        id={id}
        removeSelected={false}
        options={property ? propertyRoomFeatures[property] : []}
        onBlur={this.handleBlur}
        onChange={onChange}
      />
    );
  }
}

export default RoomFeatures;
